<template lang="html">
  <div class="wcc auth-container">
    <transition name="fade" mode="out-in">
      <Choose v-if="$store.state.auth.action == 'choose'"><Back></Back></Choose>
      <Login v-else-if="$store.state.auth.action == 'login'"><Back></Back></Login>
      <ResetPassword v-else-if="$store.state.auth.action == 'resetPassword'"><Back></Back></ResetPassword>
      <SignUp v-else-if="$store.state.auth.action == 'signUp'"><Back></Back></SignUp>
    </transition>
  </div>
</template>
<script>
  import Choose from './_choose.vue'
  import Login from './Login/_login.vue'
  import ResetPassword from './ResetPassword/_resetPassword.vue'
  import SignUp from './SignUp/_signUp.vue'
  import Back from './_back.vue'
  export default {
    components: {
      Choose,
      Login,
      ResetPassword,
      SignUp,
      Back
    }
  }
</script>
<style lang="scss">
.wcc.auth-container {
  .wcc.auth {
    h2 {
      position: relative;
    }
  }
}
</style>
